import { forwardRef, useEffect, useRef, useState } from 'react';
import Button from '../Button';
import DropdownWrapper from './style/dropdownWrapper';

const Dropdown = forwardRef((props, ref) => {
  const [isVisible, setVisible] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const { parent, items } = props;
  const menuItems = items.map((item, index) => (
    <li key={index} className='menu-item' onClick={() => setVisible(false)}>
      {item}
    </li>
  ));

  const handleClick = (event) => {
    if (
      buttonRef.current &&
      !buttonRef.current.contains(event.target) &&
      menuRef.current &&
      !menuRef.current.contains(event.target)
    ) {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      window.addEventListener('mousedown', handleClick);
    } else {
      window.removeEventListener('mousedown', handleClick);
    }

    return () => {
      window.removeEventListener('mousedown', handleClick);
    };
  }, [isVisible]);

  return (
    <DropdownWrapper {...props} ref={ref}>
      <Button
        ref={buttonRef}
        className='parent-element'
        onClick={() => setVisible((prev) => !prev)}
      >
        {parent}
      </Button>
      {isVisible && (
        <div className='dropdown-menu-container'>
          <ul className='dropdown-menu' ref={menuRef}>
            {menuItems}
          </ul>
        </div>
      )}
    </DropdownWrapper>
  );
});

Dropdown.displayName = 'Dropdown';
export default Dropdown;
